import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { CMS_COMPONENT_IMAGE_CONFIG } from './cms-component-image.config';
import { NCmsComponentImage } from './cms-component-image.interface';

@Component({
    selector: 'cms-component-image',
    templateUrl: './cms-component-image.component.html',
    standalone: true,
    imports: [HrefComponent, DfImageDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsComponentImageComponent>(CMS_COMPONENT_IMAGE_CONFIG)
export class CmsComponentImageComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsComponentImage.IData;
}
